import styled from '@emotion/styled'
import { motion } from 'framer-motion'

export const StepWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: 48px 20px;
`

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`

export const ResultIconWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isCorrect',
})<{ isCorrect: boolean }>`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background-color: ${({ isCorrect }) => (isCorrect ? 'rgba(59, 130, 246, 0.16)' : 'rgba(239, 68, 68, 0.16)')};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ResultLabel = styled('p', {
  shouldForwardProp: (prop) => prop !== 'isCorrect',
})<{ isCorrect: boolean }>`
  font-size: 26px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.39px;
  color: ${({ isCorrect }) => (isCorrect ? '#3b82f6' : '#ef4444')};
`

export const ResultText = styled.p`
  font-size: 26px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.39px;
  color: #1b1c1d;
  word-break: keep-all;
`

export const BackButton = styled.button`
  width: 100%;
  height: 56px;
  background-color: #ff5626;
  color: #ffffff;
  font-size: 17px;
  font-weight: 700;
  border: none;
  border-radius: 16px;
  padding: 12px;
  line-height: 26px;
  letter-spacing: -0.17px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:active {
    opacity: 0.85;
  }
`
